import ProductSimpleForm from './ProductSimpleForm'

export default ProductSimpleForm
